<template src="./index.html"></template>

<script>

export default {
  data: function () {
    return {
      data: {
        suosq: "2019年09期",
        companyName: "上海速元信息技术有限公司",
        lxdh: "13917588566",
        swdjh: "91310115MA1K3R189Q",
        yhzh: "121925424410906",
        zzsysxse: "88495.58",
        rjcpysxse: "88495.58",
        xxse: "11504.42",
        rjcpyxxse: "11504.42",
        jxse: "5592.89",
        rjjxse: "1029.33",
        ynzzse: "5911.53",
        rjynzzse: "10475.09",
        sjynzzse: "5911.53",
        rjyinzzse: "10475.09",
        sjzzssf: "6.68%",
        jzjtje: "7820.22",
        writeTime: "2019年10月18日",
      }
    };
  },
  created() {
  },
  mounted() {
  },
  components: {},
  methods: {
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
